import { Icon } from './types';

export const LinkedInIcon: Icon = (props) => (
  <svg viewBox={'0 0 24 24'} {...props}>
    <path
      d={
        'M6.2 21.069H1.848V7.049H6.2v14.02zM4.022 5.136C2.63 5.136 1.5 3.983 1.5 2.591a2.521 2.521 0 015.043 0c0 1.392-1.13 2.545-2.522 2.545zM22.495 21.07h-4.344v-6.825c0-1.627-.033-3.713-2.264-3.713-2.263 0-2.61 1.768-2.61 3.596v6.942h-4.35V7.049h4.176V8.96h.061c.582-1.101 2.002-2.264 4.12-2.264 4.406 0 5.216 2.902 5.216 6.67v7.702h-.005z'
      }
    />
  </svg>
);
